import { columns } from "../../../dtos/columns";
import inmobiliariaDto from "../../maestros/inmobiliarias/models/inmobiliariaDto";
import CustomTooltip from "../../../components/ui/customToolTip";
import { format } from "rut.js";
import AccionesInmobiliaria from "../../maestros/inmobiliarias/components/accionesInmobiliaria";
import { InmobiliariaWriteDto } from "../../maestros/inmobiliarias/components/inmobiliariaForm";
interface IProps {
    renderizar: () => void;
    setInmobiliariaEditar: React.Dispatch<React.SetStateAction<InmobiliariaWriteDto | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}
export function useColumnsModalInmb({ renderizar, setInmobiliariaEditar, setModalDetalle }: IProps) {

    const COLUMNS: columns<inmobiliariaDto>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesInmobiliaria
                    inmobiliaria={row}
                    renderizar={renderizar}
                    setInmobiliariaEditar={setInmobiliariaEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center',
            // width: "10%"
        },
        {
            name: 'RUT inmobiliaria',
            selector: (row) => format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Nombre inmobiliaria',
            selector: (row) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: false,
            center: true,
        },
        {
            name: 'Empresa holding',
            selector: (row) => row.nombreHolding ?? 'Sin información',
            sortable: true,
            sortField: 'nombreHolding',
            wrap: true,
            export: false,
            center: true,
        },
        {
            name: 'Convenio vigente',
            selector: (row) =>
                row.nombreConvenio,
            cell: (row) => (
                <span>
                    {(
                        <CustomTooltip text={row.descripcionConvenio ?? ''}>
                            <span>{row.nombreConvenio}</span>
                        </CustomTooltip>
                    )}
                </span>
            ),
            sortable: true,
            sortField: 'nombreConvenio',
            wrap: true,
            export: true,
            center: true
        },
    ];

    return { COLUMNS };
}